import { useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import DebugTabs from '../components/debug/debugTabs';

export default function Debug() {
  const location = useLocation();
  const isDebug = location.pathname === '/vst/debug' || location.pathname === '/streamer/debug' || location.pathname === '/mms/debug';
  return (
    <Box
      sx={{
        display: isDebug ? 'inline' : 'none',
      }}
    >
      <DebugTabs />
    </Box>
  );
}
